import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/icon/mute.svg'


const _withScopeId = n => (_pushScopeId("data-v-062a0d2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "left" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "num"
}
const _hoisted_5 = {
  key: 2,
  class: "num-notify"
}
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "content-header" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "middle-box" }
const _hoisted_10 = {
  key: 0,
  class: "middle-box-at"
}
const _hoisted_11 = { class: "content-footer" }
const _hoisted_12 = { class: "time" }
const _hoisted_13 = {
  key: 0,
  class: "mute-icon",
  src: _imports_0
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_15 = {
  key: 0,
  class: "dialog dialog-item",
  ref: "dialog"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_TUILongPress = _resolveDirective("TUILongPress")!

  return (_openBlock(), _createElementBlock("li", {
    ref: "content",
    class: _normalizeClass(["TUI-conversation-content", [
      _ctx.currentID === _ctx.conversation.conversationID && 'selected',
      _ctx.conversation.isPinned && 'pinned',
      _ctx.isH5 ? 'list-item-h5' : '',
    ]]),
    id: _ctx.conversation.conversationID
  }, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "TUI-conversation-item",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.handleListItem(_ctx.conversation)), ["prevent","stop"])),
      onContextmenu: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleDialog && _ctx.toggleDialog(...args)), ["prevent","right"]))
    }, [
      _createElementVNode("aside", _hoisted_2, [
        _createElementVNode("img", {
          class: "avatar",
          src: _ctx.handleConversation?.avator(_ctx.conversation)
        }, null, 8, _hoisted_3),
        (_ctx.showUserOnlineStatus())
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["online-status", 
            _ctx.userStatusList?.get(_ctx.conversation?.userProfile?.userID)?.statusType === 1
              ? 'online-status-online'
              : 'online-status-offline'
          ])
            }, null, 2))
          : _createCommentVNode("", true),
        (_ctx.conversation.unreadCount > 0 && _ctx.conversation.messageRemindType !== 'AcceptNotNotify')
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.conversation.unreadCount > 99 ? '99+' : _ctx.conversation.unreadCount), 1))
          : _createCommentVNode("", true),
        (_ctx.conversation.unreadCount > 0 && _ctx.conversation.messageRemindType === 'AcceptNotNotify')
          ? (_openBlock(), _createElementBlock("span", _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", null, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.handleConversation?.name(_ctx.conversation)), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.conversation.type === 'GROUP' && _ctx.conversation.groupAtInfoList.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.handleConversation?.showAt(_ctx.conversation)), 1))
              : _createCommentVNode("", true),
            _createElementVNode("p", null, _toDisplayString(_ctx.handleConversation?.showMessage(_ctx.conversation)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.handleConversation?.time(_ctx.conversation.lastMessage.lastTime)), 1),
          (_ctx.conversation.messageRemindType === 'AcceptNotNotify')
            ? (_openBlock(), _createElementBlock("img", _hoisted_13))
            : _createCommentVNode("", true),
          _hoisted_14
        ])
      ])
    ], 32)), [
      [
        _directive_TUILongPress,
        _ctx.toggleDialog,
        void 0,
        { self: true }
      ]
    ]),
    (_ctx.toggle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("p", {
            class: "conversation-options",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.handleItem('delete')), ["stop"]))
          }, _toDisplayString(_ctx.$t('TUIConversation.删除会话')), 1),
          (!_ctx.conversation.isPinned)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: "conversation-options",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.handleItem('ispinned')), ["stop"]))
              }, _toDisplayString(_ctx.$t('TUIConversation.置顶会话')), 1))
            : _createCommentVNode("", true),
          (_ctx.conversation.isPinned)
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                class: "conversation-options",
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.handleItem('dispinned')), ["stop"]))
              }, _toDisplayString(_ctx.$t('TUIConversation.取消置顶')), 1))
            : _createCommentVNode("", true),
          (_ctx.conversation.messageRemindType === '' || _ctx.conversation.messageRemindType === 'AcceptAndNotify')
            ? (_openBlock(), _createElementBlock("p", {
                key: 2,
                class: "conversation-options",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.handleItem('mute')), ["stop"]))
              }, _toDisplayString(_ctx.$t('TUIConversation.消息免打扰')), 1))
            : _createCommentVNode("", true),
          (_ctx.conversation.messageRemindType === 'AcceptNotNotify')
            ? (_openBlock(), _createElementBlock("p", {
                key: 3,
                class: "conversation-options",
                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.handleItem('notMute')), ["stop"]))
              }, _toDisplayString(_ctx.$t('TUIConversation.取消免打扰')), 1))
            : _createCommentVNode("", true)
        ], 512))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}